App.factory('Analytics', restmod => {
    return restmod.model('/analytics')
})
